import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ChangeEmailVerifyLink = gql`
  mutation ChangeEmailVerifyLink($input: ChangeEmailVerifyLinkInput!) {
    changeEmailVerifyLink(input: $input) {
      ... on ChangeEmailVerifyLinkSuccess {
        __typename
        success
      }

      ... on ChangeEmailInvalidLink {
        __typename
        ...error
      }

      ... on ChangeEmailExpiredLink {
        __typename
        ...error
      }
    }
  }
  ${error}
`;

export default ChangeEmailVerifyLink;
